import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import * as IntegrationsActions from "../../data/integrations/IntegrationsActions";

import IntegrationList from './IntegrationList';

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = {
    onDisconnect: IntegrationsActions.removeIntegration
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IntegrationList);
